import {
  Heading,
  ListItem,
  Stack,
  Text,
} from '@alefeducation/ui-elements-library-core';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import ActionMenu from './ActionMenu';
import { Organisation } from '../../apollo/queries';
import { getCountryName } from '../../utils/countries';
import { Status } from '../Organisations';

export type MenuOptionFunctionType = (organisation: Organisation) => void;
interface Props {
  organisations: Organisation[];
  onEditClick: MenuOptionFunctionType;
  onStatusClick: MenuOptionFunctionType;
  isViewOnlyRole: boolean;
}

interface ListItemProps {
  onClick?(): void;
}

const StyleListItem = styled(ListItem)<ListItemProps>`
  padding: ${({ theme: { space } }: any) =>
    `${space[24]}px ${space[32]}px ${space[24]}px ${space[24]}px`};

  cursor: pointer;

  > div {
    width: 20%;
  }
  .status-container {
    width: 10%;
  }
  .action-container {
    width: 10%;
    text-align: right;
    visibility: hidden;
  }
  :hover {
    .action-container {
      visibility: visible;
    }
  }
`;

const OrganisationsRows = ({
  organisations,
  onEditClick,
  onStatusClick,
  isViewOnlyRole,
}: Props) => {
  const history = useHistory();
  return (
    <>
      {organisations.map((organisation, index) => {
        const { name, email, country, code, isActive } = organisation;

        return (
          <StyleListItem
            key={`org-row-${index}`}
            data-testid={`organisation-row-${code}`}
            onClick={() => {
              history.push(`/organisations/${code}/members`);
            }}
          >
            <Stack
              flexDirection="column"
              justifyContent="center"
              key={`name-${name}`}
            >
              <Heading
                variant="heading-small"
                data-testid={'organisation-row-field-name'}
              >
                {name}
              </Heading>
            </Stack>

            <Stack
              flexDirection="column"
              justifyContent="center"
              key={`code-${code}`}
            >
              <Text
                data-testid={'organisation-row-field-code'}
                variant="body-large"
                color="primary.100"
                weight="light"
              >
                {code}
              </Text>
            </Stack>

            <Stack flexDirection="column" justifyContent="center" key={email}>
              <Text
                variant="body-large"
                color="primary.100"
                weight="light"
                data-testid={'organisation-row-field-email'}
              >
                {email}
              </Text>
            </Stack>

            <Stack flexDirection="column" justifyContent="center" key={country}>
              <Text
                variant="body-large"
                color="primary.100"
                weight="light"
                data-testid={'organisation-row-field-country'}
              >
                {getCountryName(country)!}
              </Text>
            </Stack>

            <Stack
              className="status-container"
              flexDirection="column"
              justifyContent="center"
              key={`isActive-${index}`}
            >
              <Status isActive={isActive} />
            </Stack>
            <Stack
              className="action-container"
              flexDirection="column"
              justifyContent="center"
              key={`action-${index}`}
            >
              <ActionMenu
                organisation={organisation}
                isActive={isActive}
                onEditClick={onEditClick}
                isViewOnlyRole={isViewOnlyRole}
                onStatusClick={onStatusClick}
              />
            </Stack>
          </StyleListItem>
        );
      })}
    </>
  );
};

export default OrganisationsRows;
